export default __webpack_public_path__ + "static/media/CNo.52-0.02f2f437.jpg";